import React from "react";
import { Card, Flex, Form, Input, Select } from "antd";
import { countries } from "../../../../../../../../shared-components/countries";

export const AddressCard = ({ themeDefault }) => {
  return (
    <Card
      bordered
      title={
        <div
          style={{
            borderBottom: themeDefault?.info?.newConfig?.cardborder,
            paddingBottom: 8,
          }}
        >
          Additional Details
        </div>
      }
    >
      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="Address1"
          label="Address 1"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter Address 1" />
        </Form.Item>

        <Form.Item
          name="Address2"
          label="Address 2"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter Address 2" />
        </Form.Item>
      </Flex>

      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="state"
          label="State"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter State" />
        </Form.Item>

        <Form.Item
          name="city"
          label="City"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter city" />
        </Form.Item>
      </Flex>

      <Flex gap={16} wrap="wrap">
        <Form.Item
          name="country"
          label="Country"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Select
            placeholder="Select country"
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={countries.map((c) => ({ value: c, label: c }))}
          />
        </Form.Item>

        <Form.Item
          name="postalCode"
          label="Postal Code"
          style={{ flex: 1, minWidth: 220, marginBottom: 8 }}
        >
          <Input placeholder="Enter Postal Code" />
        </Form.Item>
      </Flex>
    </Card>
  );
};
